import { FC } from 'react'
import Swal from 'sweetalert2'
import { RowActions, useModal, useToast } from '../../../../../../components'
import {
  showAlertLoading,
  showConfirmAlert,
  showError,
} from '../../../../../../../_metronic/helpers'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { FaturaAtendimentosModal } from '../../components/modal/FaturaAtendimentosModal'
import { FaturaAtendimentoList } from '../../core/_models'
import { deleteItemFatura } from '../../core/_requests'
import { useT } from '_metronic/i18n/Metronici18n'

type IProps = {
  faturaAtendimento: FaturaAtendimentoList
}

/**
 * Ações do item — só renderizada com a fatura "Gerada" (a coluna nem existe nos demais casos;
 * ver _columns). A situação vem do useFaturaAtual em cache, sem buscar a fatura a cada menu.
 */
export const FaturaAtendimentosActionsCell: FC<IProps> = ({ faturaAtendimento }) => {
  const { t } = useT()
  const { refetch } = useQueryResponse()
  const { showModal } = useModal()
  const { showToast } = useToast()
  const nome = `atendimento ${faturaAtendimento.atendimento?.protocolo ?? ''}`.trim()

  const openModal = (action: 'atualizar' | 'inativar') =>
    showModal({
      title: t('modal.fatura_atendimentos', {
        name: action === 'atualizar' ? t('atualizar.label') : t('inativar.label'),
      }),
      content: (
        <FaturaAtendimentosModal
          action={action}
          idFaturaAtendimento={faturaAtendimento.id}
          valorEmpresa={faturaAtendimento.valorEmpresa}
          valorProfissional={faturaAtendimento.valorProfissional}
        />
      ),
    })

  // Remover tira o item desta fatura (ele pode entrar nas próximas).
  const askRemove = async () => {
    const confirmed = await showConfirmAlert({
      title: 'Remover da fatura?',
      text: t('alert.fatura_item'),
      confirmButtonText: t('remover.label'),
      cancelButtonText: t('common.cancel'),
      danger: true,
    })
    if (!confirmed) return

    try {
      showAlertLoading()
      await deleteItemFatura(faturaAtendimento.id)
      Swal.close()
      showToast({
        variant: 'success',
        title: t('alert.removido', { name: t('item.label'), gender: t('item.gender') }),
      })
      refetch()
    } catch (error) {
      showError(error)
    }
  }

  return (
    <RowActions
      itemName={nome}
      items={[
        { label: t('atualizar.label'), onClick: () => openModal('atualizar') },
        {
          label: t('inativar.label'),
          onClick: () => openModal('inativar'),
          hidden: !faturaAtendimento.ativa,
        },
        { label: t('remover.label'), onClick: askRemove, danger: true, divider: true },
      ]}
    />
  )
}
